import { translate } from "@/config/translator";
import { CookiePreferenceEnum } from "@/config/types";
import Header from "@/components/header/header";
import { TopBarMobile } from "@/components/topBarMobile/topBarMobile";
import Box from "@/components/box/box";
import PspSelect from "@/components/pspSelect/pspSelect";
import PspButton from "@/components/pspButton/PspButton";
import ChangePasswordDialog from "./changePasswordDialog";
import { useSettings } from "./settings/useSettings";
import { clsx } from "clsx/lite";
import { MfaSettings } from "./settings/mfaSettings";

export default function Settings() {
  const {
    isTablet,
    navigate,
    onChangePassword,
    onSave,
    somethingChanged,
    lang,
    selectedLanguage,
    setSelectedLanguage,
    setChangePasswordDialogIsOpen,
    cookiePreference,
    setCookiePreference,
    wrongPassword,
    setWrongPassword,
    changePasswordDialogIsOpen,
    changePasswordButtonDisabled,
    passwordRequirements,
    setPasswordRequirements,
  } = useSettings();

  return (
    <>
      {!isTablet && (
        <TopBarMobile onBack={() => navigate(-1)} header="settings" />
      )}
      <div className="p-6 tablet:p-10 h-full flex flex-col justify-between">
        {/* HEADER */}
        <div className="flex flex-col gap-6">
          <Header
            text="settings"
            mainButtonDisabled={!somethingChanged}
            mainButtonText="save"
            onMainButtonClick={onSave}
          />
          <Box>
            <div
              className={clsx(
                "grid",
                "gap-x-10",
                "tablet:gap-x-20",
                "desktop:gap-x-40",
                "gap-y-8",
                "grid-cols-1",
                "tablet:grid-cols-2",
              )}
            >
              {/* LANGUAGE */}
              <PspSelect
                onChange={setSelectedLanguage}
                value={selectedLanguage ?? ""}
                labelString={translate("language", lang)}
              >
                {/* GERMAN */}
                <option value={"de"}>{translate("german", lang)}</option>

                {/* ITALIAN */}
                <option value={"it"}>{translate("italian", lang)}</option>

                {/* ENGLISH */}
                <option value={"en"}>{translate("english", lang)}</option>
              </PspSelect>
              <div className="flex flex-col justify-end">
                {/* CHANGE PASSWORD */}
                <PspButton
                  size="large"
                  appearance="secondary"
                  onClick={
                    isTablet
                      ? () => setChangePasswordDialogIsOpen(true)
                      : () => navigate("/settings/change-password")
                  }
                >
                  {translate("changePassword", lang)}
                </PspButton>
              </div>

              {/* COOKIE PREFERENCES */}
              <PspSelect
                onChange={setCookiePreference}
                value={cookiePreference}
                labelString={translate("cookiePreferences", lang)}
              >
                {/* ALL */}
                <option value={CookiePreferenceEnum.ALL}>
                  {translate("allCookies", lang)}
                </option>

                {/* FUNCTIONAL ONLY */}
                <option value={CookiePreferenceEnum.ESSENTIAL_ONLY}>
                  {translate("essentialCookies", lang)}
                </option>
              </PspSelect>
            </div>
          </Box>

          {/* MFA */}
          <MfaSettings />
        </div>

        {/* SAVE BUTTON MOBILE */}
        {!isTablet && (
          <PspButton
            onClick={onSave}
            className="tablet:hidden mb-4"
            disabled={!somethingChanged}
            appearance="primary"
          >
            {translate("save", lang)}
          </PspButton>
        )}

        {/* CHANGE PASSWORD DIALOG */}
        {isTablet && (
          <ChangePasswordDialog
            isOpen={changePasswordDialogIsOpen}
            onClose={() => setChangePasswordDialogIsOpen(false)}
            wrongPassword={wrongPassword}
            setWrongPassword={setWrongPassword}
            onSaveNewPassword={onChangePassword}
            passwordRequirements={passwordRequirements}
            changePasswordButtonDisabled={changePasswordButtonDisabled}
            setPasswordRequirements={setPasswordRequirements}
          />
        )}
      </div>
    </>
  );
}
